module.exports = __webpack_public_path__ + "static/media/dst-logo-purple.20512372.svg";